module.exports = __webpack_public_path__ + "img/bledpet.762ddbf6.svg";